// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__S14sE","text":"styles_text__B1ETh","textarea":"styles_textarea__wVGwK"};